import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar"]
  static values = {
    sidebarId: { type: String, default: "mySidenav" }
  }

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeydown)
  }

  open(event) {
    event.preventDefault()
    const sidebar = this.hasSidebarTarget
      ? this.sidebarTarget
      : document.getElementById(this.sidebarIdValue)

    if (sidebar) {
      this.lastActiveElement = document.activeElement
      sidebar.style.left = "0px"
      sidebar.setAttribute("aria-hidden", "false")

      // Make focusable elements accessible
      this.setFocusableElements(sidebar, true)

      // Update ARIA state on trigger button
      const trigger = document.querySelector('[aria-controls="mySidenav"]')
      if (trigger) trigger.setAttribute('aria-expanded', 'true')

      // Focus first link in sidebar for keyboard users
      const closeButton = sidebar.querySelector('button.closebtn')
      const firstLink = sidebar.querySelector('a')
      const focusTarget = closeButton || firstLink
      if (focusTarget) focusTarget.focus()
    }
  }

  close(event) {
    if (event) event.preventDefault()
    const sidebar = this.hasSidebarTarget
      ? this.sidebarTarget
      : document.getElementById(this.sidebarIdValue)

    if (sidebar) {
      sidebar.style.left = "-250px"
      sidebar.setAttribute("aria-hidden", "true")

      // Make focusable elements inaccessible
      this.setFocusableElements(sidebar, false)

      // Update ARIA state and return focus to trigger
      const trigger = document.querySelector('[aria-controls="mySidenav"]')
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false')
      }
      if (this.lastActiveElement && this.lastActiveElement.focus) {
        this.lastActiveElement.focus()
        this.lastActiveElement = null
      } else if (trigger) {
        trigger.focus()
      }
    }
  }

  setFocusableElements(container, focusable) {
    const elements = container.querySelectorAll('a, button, input, select, textarea, [tabindex]')
    elements.forEach(el => {
      if (focusable) {
        el.removeAttribute('tabindex')
      } else {
        el.setAttribute('tabindex', '-1')
      }
    })
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      const sidebar = this.hasSidebarTarget
        ? this.sidebarTarget
        : document.getElementById(this.sidebarIdValue)

      if (sidebar && sidebar.style.left === '0px') {
        this.close(event)
      }
    }
  }
}
